const GrupoDeRotasHome = () => import(/* webpackChunkName: "group-pabx-cadastros-grupo-de-rotas" */ '../_views/GrupoDeRotasHome')
const CadastroGrupoDeRotas = () => import(/* webpackChunkName: "group-pabx-cadastros-grupo-de-rotas" */ '../_views/CadastroGrupoDeRotas')
const AtualizarGrupoDeRotas = () => import(/* webpackChunkName: "group-pabx-cadastros-grupo-de-rotas" */ '../_views/AtualizarGrupoDeRotas')

import { permissionsPabx } from '../../../../../../utils/permissionsPabx'

export default [
  {
    path: 'grupos-de-rotas',
    component: GrupoDeRotasHome,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'GrupoRotas',
  },
  {
    path: 'grupos-de-rotas/criar',
    component: CadastroGrupoDeRotas,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'GrupoRotas/criar',
  },
  {
    path: 'grupos-de-rotas/atualizar/:_id',
    component: AtualizarGrupoDeRotas,
    meta: { requiresAuth: true, permissions: [...permissionsPabx] },
    name: 'GrupoRotas/atualizar',
    props: true,
  },
]